<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
export let label;
export let formats = [];
export let onSelect = () => {};

let isOpen = false;
let menuContainer;

function toggleMenu() {
  if (formats.length === 0) return;
  isOpen = !isOpen;
}

function selectFormat(format) {
  isOpen = false;
  onSelect(format);
}

function closeMenu() {
  isOpen = false;
}

function handleClickOutside(event) {
  if (menuContainer && !menuContainer.contains(event.target)) {
    closeMenu();
  }
}

function handleKeydown(event) {
  if (event.key === 'Escape') {
    closeMenu();
  }
}
</script>

<svelte:window on:click={handleClickOutside} on:keydown={handleKeydown} />

<div class="download-format-menu" bind:this={menuContainer}>
  <button
    type="button"
    class="secondary download-format-trigger"
    aria-haspopup="menu"
    aria-expanded={isOpen}
    disabled={formats.length === 0}
    on:click|stopPropagation={toggleMenu}
  >
    <span>{label}</span>
    <svg
      class="download-format-caret"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 256 256"
    >
      <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
    </svg>
  </button>

  {#if isOpen}
    <div class="download-format-dropdown" role="menu">
      {#each formats as format}
        <button
          type="button"
          class="download-format-option"
          role="menuitem"
          on:click={() => selectFormat(format)}
        >
          .{format}
        </button>
      {/each}
    </div>
  {/if}
</div>

<style>
  .download-format-menu {
    position: relative;
    display: inline-flex;
    align-self: stretch;
  }

  .download-format-trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 100%;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .download-format-trigger:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  .download-format-caret {
    flex-shrink: 0;
  }

  .download-format-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    z-index: 20;
    min-width: 100%;
    width: max-content;
    max-height: 240px;
    overflow-y: auto;
    padding: 6px;
    background-color: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 8px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  .download-format-option {
    width: 100%;
    display: block;
    margin: 0;
    padding: 8px 14px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #222;
    text-align: left;
    font-size: 0.95rem;
    font-weight: 500;
    text-transform: none;
    cursor: pointer;
  }

  .download-format-option:hover,
  .download-format-option:focus-visible {
    background-color: #f4f4f4;
    outline: none;
  }
</style>
